import { render, staticRenderFns } from "./insuranceFailure.vue?vue&type=template&id=0439e948&scoped=true"
import script from "./insuranceFailure.vue?vue&type=script&lang=js"
export * from "./insuranceFailure.vue?vue&type=script&lang=js"
import style0 from "./insuranceFailure.vue?vue&type=style&index=0&id=0439e948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0439e948",
  null
  
)

export default component.exports